/* ===== 1.Осноные компоненты react ===== */
import React from "react";

/* ===== 2.Локальные компоненты ===== */
import { navigation } from "../../data";
import PriorityNav from "../../components/ui/PriorityNav/PriorityNav";

/* ===== 4.Стили ===== */
import s from "./Footer.module.scss";

const cx = (...a) => a.filter(Boolean).join(" ");

function FooterLink({ href, children, className }) {
    if (!href) return <span className={cx(s.text, className)}>{children}</span>;
    return (
        <a className={cx(s.link, className)} href={href}>
            {children}
        </a>
    );
}

function Footer({ data }) {

    if (!data) return null;

    const { brand, nav, contacts, legal, bottom } = data;


    return (
        <footer className={s.footer} id="footer">
            <div className={s.container}>
                <div className={s.top}>
                    {/* Brand */}
                    <div className={s.col}>
                        <div className={s.brand}>
                            {brand.logoSrc && <img className={s.logo} src={brand.logoSrc} alt={brand.title} />}
                            <div className={s.brandTitle}>{brand?.title}</div>
                            {brand?.description && <div className={s.brandDesc}>{brand.description}</div>}
                        </div>
                    </div>

                    {/* Nav */}
                    {nav?.links?.length ? (
                        <div className={s.col}>
                            <div className={s.colTitle}>{nav.title || "Навигация"}</div>
                            <div className={s.navContainer}>
                                <PriorityNav items={navigation} variant="footer" />
                            </div>
                        </div>
                    ) : null}

                    {/* Contacts */}
                    {(contacts?.items?.length || contacts?.socials?.length) ? (
                        <div className={s.col}>
                            <div className={s.colTitle}>{contacts.title || "Контакты"}</div>

                            {contacts?.items?.length ? (
                                <ul className={s.list}>
                                    {contacts.items.map((c, i) => (
                                        <li key={i}>
                                            <FooterLink href={c.href}>{c.label}</FooterLink>
                                        </li>
                                    ))}
                                </ul>
                            ) : null}

                            {contacts?.socials?.length ? (
                                <div className={s.socials}>
                                    {contacts.socials.map((x, i) => (
                                        <a
                                            key={i}
                                            className={s.social}
                                            href={x.href}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {x.label}
                                        </a>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>

                {/* Bottom */}
                <div className={s.bottom}>
                    <div className={s.bottomLeft}>
                        <div className={s.muted}>{bottom?.copyright}</div>

                        {legal?.links?.length ? (
                            <div className={s.legal}>
                                {legal.links.map((l, i) => (
                                    <React.Fragment key={i}>
                                        <a className={s.legalLink} href={l.href}>
                                            {l.label}
                                        </a>
                                        {i !== legal.links.length - 1 && <span className={s.dot}>•</span>}
                                    </React.Fragment>
                                ))}
                            </div>
                        ) : null}
                    </div>

                    {bottom?.madeBy ? <div className={s.muted}>{bottom.madeBy}</div> : null}
                </div>
            </div>
        </footer>
    );
}

export default Footer;